export const CUKCUK_DEFAULT_CITY = 'HCM';
export const CUKCUK_PARSER_VERSION = '2.2.0';
export const CUKCUK_PREVIEW_MAX_ROWS = 500;
export const CUKCUK_MIN_MATCH_SCORE = 600;
export const FIRESTORE_BATCH_SIZE = 500;
export const FIRESTORE_IN_QUERY_LIMIT = 30;

export const CUKCUK_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;

/** Collections CUKCUK — tách riêng, không ghi đè iPOS. */
export const CUKCUK_DISHES_COLLECTION = 'cukcuk_dishes';
export const CUKCUK_CUSTOMIZATION_COLLECTION = 'cukcuk_customization';
export const CUKCUK_INVOICE_NOTIFICATIONS_COLLECTION = 'cukcuk_invoice_notifications';
export const CUKCUK_IMPORTS_COLLECTION = 'cukcuk_imports';

/** Collections iPOS (legacy) — giữ nguyên, không dùng khi import CUKCUK. */
export const IPOS_DISHES_COLLECTION = '8am_dishes';
export const IPOS_CUSTOMIZATION_COLLECTION = '8am_customization';
export const IPOS_INVOICE_NOTIFICATIONS_COLLECTION = 'invoice_notifications';